import React from 'react'

const Button = ({text,textColor,bgColor,disabled, onClick}) => {
  return (
    <div>
        <button disabled={disabled} onClick={onClick} className={`text-center transition-transform duration-300 ${disabled ? '' : 'hover:scale-105 hover:bg-blue-600'} ${bgColor} ${textColor} border border-[#67707f] rounded-full 2xl:py-4 py-3 font-semibold w-full`}>
             {text} 
        </button>
    </div>
  )
}

export default Button